import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { useLanguage, localizedPath } from "../lib/i18n";

// Abschluss-Block mit Kontaktaufforderung — am Ende von Start und Über mich
export const ClosingCta = () => {
  const { t, lang } = useLanguage();
  return (
    <section className="border-t border-black/10 bg-coal" data-testid="closing-cta">
      <div className="mx-auto max-w-7xl px-6 py-12 text-center md:px-12 md:py-16 lg:px-16">
        <Reveal>
          <p
            data-testid="closing-cta-line"
            className="mx-auto max-w-3xl font-serif text-3xl font-light leading-snug text-bone md:text-5xl"
          >
            {t("Erzähl mir von deinem Projekt.")}
          </p>
          <Link
            to={localizedPath("/kontakt", lang)}
            data-testid="closing-cta-contact"
            className="mt-10 inline-flex items-center gap-3 border border-ember-deep bg-ember-deep px-10 py-4 font-mono text-[11px] uppercase tracking-[0.25em] text-obsidian transition-colors duration-300 hover:bg-transparent hover:text-ember-deep"
          >
            {t("Projekt anfragen")} <ArrowRight size={14} />
          </Link>
        </Reveal>
      </div>
    </section>
  );
};
